/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: require('./Modal'),
    slot: {
        body: ['html', {
            'class': 'uk-modal-dialog',
            $html: [{
                tag:'button',
                'class':'uk-modal-close uk-close'
            },{
                'class':'uk-modal-header',
                $html:{
                    tag:'h2',
                    'class':'header-title',
                    $html:nb.bind('title')
                }
            },{
                'class':'modal-content',
                $slot:'content'
            },{
                'class':'uk-modal-footer',
                $slot:'footer'
            }]
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/modal/Dialog.js
// module id = 8
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 32 34 35 36